import React from "react";

export const Card = ({ children, className = "" }) => (
  <div className={`rounded ${className}`}>{children}</div>
);

export const CardContent = ({ children, className = "" }) => (
  <div className={` ${className}`}>{children}</div>
);
